import { connectAuthEmulator, getAuth } from 'firebase/auth';
import type firebase from 'firebase/compat/app';

import { Logger } from '@gitbook/util-debug';

import { connectFirestoreEmulator, getFirestore } from './firestore';

const logger = Logger('emulators');

/**
 * Connect an application to the Firebase emulators.
 * Only if environment variables have been passed by firebase-tools.
 *
 * Returns true if it did connected to an emulator.
 */
export function connectToFirebaseEmulators(app: firebase.app.App): boolean {
    if (process.env.FIRESTORE_EMULATOR_HOST) {
        logger.info(`connect to firestore emulator "${process.env.FIRESTORE_EMULATOR_HOST}"`);
        connectFirestoreEmulator(
            getFirestore(app),
            ...extractEmulatorHost(process.env.FIRESTORE_EMULATOR_HOST)
        );
    }
    if (process.env.FIREBASE_AUTH_EMULATOR_HOST) {
        logger.info(`connect to auth emulator "${process.env.FIREBASE_AUTH_EMULATOR_HOST}"`);
        connectAuthEmulator(getAuth(app), `http://${process.env.FIREBASE_AUTH_EMULATOR_HOST}/`);

        if (!process.env.FIRESTORE_EMULATOR_HOST) {
            logger.warning(
                'using auth emulator, while not using the firestore emulator. Have you forgotten to start all emulators?'
            );
        }
    }
    if (process.env.FIREBASE_STORAGE_EMULATOR_HOST) {
        logger.info(`connect to storage emulator "${process.env.FIREBASE_STORAGE_EMULATOR_HOST}"`);
        app.storage().useEmulator(
            ...extractEmulatorHost(process.env.FIREBASE_STORAGE_EMULATOR_HOST)
        );

        if (!process.env.FIRESTORE_EMULATOR_HOST) {
            logger.warning(
                'using auth emulator, while not using the firestore emulator. Have you forgotten to start all emulators?'
            );
        }
    }
    if (process.env.FIREBASE_FUNCTIONS_HOST) {
        logger.info(`connect to functions emulator "${process.env.FIREBASE_FUNCTIONS_HOST}"`);
        app.functions().useEmulator(...extractEmulatorHost(process.env.FIREBASE_FUNCTIONS_HOST));
    }

    return Boolean(process.env.FIRESTORE_EMULATOR_HOST);
}

/**
 * Split a env like "127.0.0.1:5000" into a tupple [host,port]
 */
function extractEmulatorHost(host: string): [string, number] {
    const parts = host.split(':');
    return [parts[0], Number(parts[1])];
}
